import Lottie from "lottie-react";
import { lottieMap } from "../maps/lottieMap";

export default function Lot(props) {
    return (
        <Lottie animationData={lottieMap[props.children]}/>
    )
}